<template>
    <div id="new-busi-form" :class="fullScreen ? 'full-screen' : ''">
        <div class="new-head">
            <div class="head-left">
                <img src="/images/articleHeadLogo.png" />
                <div class="head-title">
                    <div class="head-span">
                        <span class="moduleT">分班管理</span>
                        <span>新增学生分班</span>
                    </div>
                </div>
            </div>
            <div class="head-right">
                <el-button @click="close">
                    <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                    关 闭
                </el-button>
                <template>
                    <el-button type="primary" @click="fenban">
                        一键分班
                    </el-button>
                </template>
            </div>
        </div>
        <div class="busi-box">
            <div class="busi-content" style="width: 300px;">
                <div class="title">{{ this.root.title }}级</div>
                <div style="height: 0;flex: 1;overflow-y: auto;">
                    <GiantTree :nodes="classTreeData" @onClick="onTreeNodeClick" />
                </div>
            </div>
            <div class="busi-content" style="width: 0;flex: 1;">
                <template v-if="isShowTable">
                    <loadTable ref="loadTable" :selectedMajorId="vo.selectedMajorId" :selectedClassCode="selectedClassCode" />
                </template>
            </div>
        </div>
        <el-dialog title="分班设置" v-if="isShowForm" v-el-drag-dialog :visible.sync='isShowForm' width='1000px'
            :close-on-click-modal='false' destroy-on-close>
            <BusiForm ref="busiform" :vo="vo" :canEdit="canEdit" />
            <span slot='footer' class='dialog-footer'>
                <el-button @click='isShowForm = false'>关 闭</el-button>
                <el-button type='primary' @click='save'>保 存</el-button>
            </span>
        </el-dialog>
        <select-dialog />
    </div>
</template>

<script>
export default {
    data() {
        return {
            classTreeData: [],
            root: null,
            formTitle: "新生登记表",
            vo: {
                selectedMajorId: null
            },
            canEdit: 1,
            isShowForm: false,
            isShowTable: false,
            selectedClassCode: null
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            // 获得今年
            const year = new Date().getFullYear()
            this.root = { id: 'sys', name: this.rootName, open: true, title: year }
            this.getClassTreeData()
        },
        async getClassTreeData() {
            const { body, code, message } = await this.$http.get('/xsgl/freshmanClazzDivide/findDivideTreeNodeVO')
            if (code === 'success') {
                this.classTreeData = this.treeDataAdapter(body.listdata)
            } else {
                this.$message.error(message)
            }
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (node.parentId === null) {
                    node.pId = this.root.id
                } else if (node.parentId !== undefined && node.parentId !== null) {
                    node.pId = node.parentId
                }
                node.title = node.name
            })
            return treeData
        },
        onTreeNodeClick(evt, treeId, treeNode) {
            let selectedMajorId = ''
            this.selectedClassCode = treeNode.classId
            if (treeNode.classId == null) {
                selectedMajorId = treeNode.id
            } else {
                selectedMajorId = treeNode.parentId
            }
            this.vo = {
                selectedMajorId
            }
            this.loadTableTemplate()
        },
        fenban() {
            if (this.vo.selectedMajorId == null) {
                this.$alert('请选择一个专业', '操作提示', {
                    type: 'warning'
                })
                return
            }
            console.log('loadTable',this.$refs.loadTable.divideClassType)
            this.vo = {
                selectedMajorId: this.vo.selectedMajorId,
                divideClassType:this.$refs.loadTable.divideClassType
            }
            const formTemplate = '#/dcontent/vuebusiform/W/xsgl.freshmanClazzDivide.form.vue'
            this.$options.components['BusiForm'] = this.$loadComponent(formTemplate)
            this.isShowForm = true
        },
        save() {
            this.formValidate(async () => {
                const fenbanClassList = this.$refs.busiform.fenbanClassList
                if (this.$refs.busiform.checkFenbanClassListIsNotEmpty()) {
                    console.log(fenbanClassList)
                    const data = fenbanClassList
                    const { code, message } = await this.$http({
                        method: 'post',
                        url: '/xsgl/freshmanClazzDivide/startBatchDivide',
                        data
                    })
                    if (code == 'success') {
                        this.isShowForm = false
                        this.getClassTreeData()
                        this.loadTableTemplate()
                        this.$message.success(message)
                        this.inserLog('开始分班')
                    } else {
                        this.$message.error(message)
                    }
                }
            }, null, 1)
        },
        loadTableTemplate() {
            const formTemplate = `#/dcontent/vuelistpage/xsgl.freshmaRregistration.list_vUMs3n.vue`
            this.$options.components['loadTable'] = this.$loadComponent(formTemplate)
            this.isShowTable = true
        },
        async inserLog(operateDesc, importModule = "待分班", fileName = "分班管理") {
            const { body } = await this.$http({
                method: 'post',
                url: '/xsgl/updateLog/addNew'
            })
            const vo = body.vo
            vo.fileName = fileName
            vo.importModule = importModule
            vo.operateDesc = `执行了${operateDesc}操作`
            const { code, message } = await this.$http({
                method: 'post',
                url: '/xsgl/updateLog/insert',
                data: vo
            })
            if (code != 'success') {
                this.$message.error(message)
            }
        },
        close() {
            window.close()
        },
    }
}
</script>

<style scoped lang="scss">
#new-busi-form {
    height: 100%;
    background: #f0f2f5;

    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        background: white;
        align-items: center;

        .head-left {
            display: flex;
            align-items: center;

            img {
                width: 44px;
                height: 44px;
            }

            .head-title {
                margin-left: 10px;
                font-size: 14px;
                color: #999999;

                .moduleT {
                    margin-right: 13px;
                    position: relative;
                }

                .moduleT::after {
                    position: absolute;
                    content: '';
                    width: 1px;
                    height: 12px;
                    right: -8px;
                    top: 50%;
                    background: #999999;
                    transform: translateY(-50%);
                }
            }
        }
    }

    .busi-box {
        height: calc(100% - 68px);
        overflow: auto;
        display: flex;
        padding: 10px 10px;
        gap: 10px;

        // padding-top: 20px;
        .busi-content {
            background: white;
            min-height: 100%;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
            display: flex;
            flex-direction: column;

            .title {
                padding: 10px;
                border-bottom: 1px solid #e8e8e8;

            }

            .busi-components {
                padding: 0 100px;
            }
        }

    }

}
</style>
